<template>
  <div class="c2">
    <div class="c2-content">
      <div
        class="text-area"
        ref="content"
        @mouseenter="mouseenterEvent()"
        @mouseleave="mouseleaveEvent()"
      >
        <div class="list-content" ref="scroll1">
          <div
            class="list-item"
            v-for="(item, i) in defaultdata"
            :key="i"
            :class="{ active: activeIndex === i }"
            @click="handleClick(i)"
          >
            <div class="id_bg">
              <p>{{ i + 1 }}</p>
            </div>
            <div class="text_box">
              <p>{{ item.value1 }}</p>
              <span>{{ item.value2 }}</span>
            </div>
          </div>
        </div>
        <div class="list-content" ref="scroll2" v-if="defaultdata.length > 7">
          <div
            class="list-item"
            v-for="(item, i) in defaultdata"
            :key="i"
            :class="{ active: activeIndex === i }"
            @click="handleClick(i)"
          >
            <div class="id_bg">
              <p>{{ i + 1 }}</p>
            </div>
            <div class="text_box">
              <p>{{ item.value1 }}</p>
              <span>{{ item.value2 }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as methods from "./method.js";
export default {
  name: "template.scope101",
  props: {
    vdata: {
      type: Array,
      default: () => [],
    },
    jsondata: {
      type: [Array, String],
      default: () => [],
    },
    valuemap: {
      type: [Array, String],
      default: () => [],
    },
    scopedata: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      // isList: true,
      textnum: 127,
      timer: null,
      defaultdata: [
        {
          value1: "内蒙古自治区和林格尔县落逃28年路家嫌犯靠放羊-漂白身份事件",
          value2: "一级 A5.1.5其他治安案事件",
        },
        {
          value1: "内蒙古自治区和林格尔县落逃28年路家嫌犯靠放羊-漂白身份事件",
          value2: "一级 A5.1.5其他治安案事件",
        },
        {
          value1: "内蒙古自治区和林格尔县落逃28年路家嫌犯靠放羊-漂白身份事件",
          value2: "一级 A5.1.5其他治安案事件",
        },
        {
          value1: "内蒙古自治区和林格尔县落逃28年路家嫌犯靠放羊-漂白身份事件",
          value2: "一级 A5.1.5其他治安案事件",
        },
        {
          value1: "内蒙古自治区和林格尔县落逃28年路家嫌犯靠放羊-漂白身份事件",
          value2: "一级 A5.1.5其他治安案事件",
        },
        {
          value1: "内蒙古自治区和林格尔县落逃28年路家嫌犯靠放羊-漂白身份事件",
          value2: "一级 A5.1.5其他治安案事件",
        },
        {
          value1: "内蒙古自治区和林格尔县落逃28年路家嫌犯靠放羊-漂白身份事件",
          value2: "一级 A5.1.5其他治安案事件",
        },
      ],
      valueMap: [
        { name: "内容", key: "value1" },
        { name: "标注", key: "value2" },
        { name: "更新时间(s)", key: "value3" },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
      scopelist: [],
      iscontact: false,
      activeIndex: 0, // 新增状态，记录当前选中的项的索引
      timer1: null
    };
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        const box = this.$refs.content;
        box.scrollTop = 0;
        this.defaultdata = n;
      }
    },
    jsondata(n) {
      this.exceldata = n;
    },
    defaultdata(n) {
      if (n && n.length) {
        console.log('___deeeeeechange', n)
        this.handleClick(0)
        clearInterval(this.timer1)
        this.timer1 = null
        if (n && +n[0].value3) {
          this.timer1 = setInterval(() => {
            let vindex = this.activeIndex + 1
            if (vindex == n.length) {
              vindex = 0
            }
            this.handleClick(vindex)
            console.log('___vvvvval', n.length)
          }, +n[0].value3 * 1000);
        }
      }
    }
  },
  mounted() {
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata;
    }
    this.setData()
    this.rollUp(150)
  },

  methods: {
    ...methods,
    rollUp(t) {
      const ulf1 = this.$refs.scroll1;
      const box = this.$refs.content;
      if (ulf1.offsetHeight > 120) {
        box.scrollTop = 0;
        this.timer = setInterval(this.rollStart, t);
      } else if (ulf1.offsetHeight == 0) {
        setTimeout(() => {
          this.rollUp(150);
        }, 200);
      }
    },
    rollStart() {
      const ulf1 = this.$refs.scroll1;
      const box = this.$refs.content;
      if (box.scrollTop >= ulf1.scrollHeight) {
        box.scrollTop = 0;
      } else {
        box.scrollTop += 2;
      }
    },
    mouseenterEvent() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    mouseleaveEvent(t) {
      if (!this.timer) {
        this.timer = setInterval(this.rollStart, 150);
      }
    },
    handleClick(index) {
      if (index != 0 && this.activeIndex == index) return
      this.activeIndex = index; // 点击时更新选中项的索引
      console.log('___vvvvindex', this.activeIndex, index)
      this.$emit('apichange', this.defaultdata[index])
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
    clearInterval(this.timer1)
    this.timer1 = null
  },
};
</script>

<style scoped lang="scss">
.c2 {
  width: 100%;
  height: 850px;
  padding: 10px 0 20px 0;
  z-index: 1;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  .c2-content {
    height: 100%;
  }
  .list-item {
    margin: 0px 0 8px 25px;
    width: 406px;
    height: 88px;
    display: flex;
    align-items: center;
    padding: 12px 0;
    background: url("../../assets/temimg13/tem13_text_bg1.png") no-repeat;
    background-size: 100% 100%;
    position: relative;

    .id_bg {
      position: absolute;
      left: -20px;
      width: 44px;
      height: 38px;
      z-index: 10;
      background: url("../../assets/temimg13/id_bg1.png") no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      p {
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
      }
    }
    .text_box {
      //   display: flex;
      padding: 8px 46px 0;
      box-sizing: border-box;

      > p {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        line-height: 24px;
        margin-bottom: 8px;
      }
      > span {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 12px;
        color: #009aff;
        line-height: 21px;
      }
    }
  }

  .list-icon {
    width: 32px;
    height: 13px;
    position: relative;

    img {
      width: 17px;
      height: 13px;
      position: absolute;
      right: 0;
    }
  }

  .text-area {
    pointer-events: auto;
    max-height: 850px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 0;
    }
  }

  // 新增选中状态的样式
  .list-item.active {
    background: url("../../assets/temimg13/tem13_text_bg1_active.png") no-repeat;
    background-size: 100% 100%;
    box-shadow: 0 0 3px 3px RGBA(6, 58, 135, 0.5);
    .id_bg p {
      color: #00ffd8;
    }
    .text_box {
      > p {
        color: #00ffd8;
      }
    }
  }
}
</style>
